import 'css-chunk:src/applications/PaymentsApp/components/PaymentSources/PaymentSources.scss';export default {
  "PaymentSourcesTitle": "_PaymentSourcesTitle_10f33_1"
};